export default __webpack_public_path__ + "static/hed-circle-5b17b4c653038d97102e3438cffb363e.png";